import * as smsList from '../services/smsList';

export default {
  namespace: 'smsList',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getSmsList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(smsList.getSmsList, values);
      yield put({
        type: 'save',
        payload: {
          smsList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *deleteTempMsg({ payload: { values }, callback }, { call, put }) {
      const response = yield call(smsList.deleteTempMsg, values);
      yield put({
        type: 'save',
        payload: {
          smsList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
